import React from 'react';
import { useSelector } from 'react-redux';
import { selectDataForRecommendedProduct } from 'formal_quote/selectors';

const RecommendedProduct = () => {
  const data = useSelector(selectDataForRecommendedProduct);

  const renderColumn = (label, value) => {
    if (!value) return null;

    return (
      <div className="flex-column text-nowrap">
        <div className="label">{label}</div>
        <div className="value">{value}</div>
      </div>
    );
  };

  // When a user wants to renew a license there is no recommended product
  if (data.looking_for === 'renew_license') {
    return null;
  }

  return (
    <div className="recommended-product">
      <div className="title">Recommended Product</div>
      <div className="container-fluid selection-box">
        <div className="row flex-row">
          {renderColumn('Product', data.productName)}
          {renderColumn('Quote Type', data.licenseScope)}
          {renderColumn(data.numberOfUsersLabel, data.numberOfUsers)}
          {renderColumn('License Type', data.licenseType)}
          {renderColumn('Delivery Method', data.deliveryMethod)}
        </div>
      </div>
    </div>
  );
};

export default RecommendedProduct;
